// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyProps } from "@insite/mobius/Typography";
import { productBrandStyles } from "@synd/Overrides/Components/ProductBrand";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

const nameText: TypographyProps = {
    css: css`
        width: fit-content;
        ${wrapInContainerStyles}
        text-transform: uppercase;
    `,
    ...fontConfig.xxSmallSingleLine,
    weight: fontConfig.weight.medium,
};
productBrandStyles.nameLink = {
    mergeCss: true,
    typographyProps: nameText,
    css: css`
        width: fit-content;
    `
};
